import { all, call, put } from 'redux-saga/effects';

import { getWorkflowByIdV2 } from 'api/WorkflowsAPI';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { getErrorResponse } from 'utils/xhr';
import { WorkflowType } from '../../enums';
import { getNewWorkflowData, isNewWorkflow } from '../../utils';
import { FetchWorkflowRequestAction, actions } from '../actions';

export default function* fetchWorkflowSaga(action: FetchWorkflowRequestAction) {
  const { workflowId, workflowType, shouldFetchClonedFromJourney } = action.payload;

  try {
    // this will be set to false in fetchAdditionalWorkflowSaga
    yield put(actions.updateIsAsyncLoading(true));
    const isNew = isNewWorkflow(workflowId);
    const newWorkflowType = WorkflowType.DRAFT;

    const [{ data }] = yield all([
      // gets the workflow data
      isNew
        ? getNewWorkflowData(workflowId, newWorkflowType)
        : call(getWorkflowByIdV2, workflowId, workflowType),
    ]);

    const { workflow } = data;
    const { nodes = [] } = workflow;

    yield put(actions.updateHasUnsavedChanges(false));
    yield put(
      actions.fetchWorkflowResponse(
        { ...workflow, nodes },
        { shouldFetchClonedFromJourney, shouldValidateNodes: true },
      ),
    );
  } catch (error) {
    yield put(actions.updateIsAsyncLoading(false));
    const err = getErrorResponse(error);
    const message = 'Something went wrong.';
    yield put(actions.fetchWorkflowError(err));

    yield put(
      addNegativeToastWithErrorId(message, 'fetchWorkflowSaga', {}, {}, [
        {
          title: 'Try again?',
          href: `/workflows/${workflowId}/edit?mode=beta&workflowType=${workflowType}`,
        },
      ]),
    );
  }
}
